import React from 'react';
import { Box, TextField, Button, CircularProgress } from '@mui/material';
import '../styles/MovieForm.css';

const MovieForm = ({ movie, setMovie, onSubmit, isLoading }) => {
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit();
    };

    return (
        <Box 
            component="form" 
            onSubmit={handleSubmit} 
            sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: 2,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                padding: 3,
                borderRadius: 2,
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}
        >
            <TextField
                label="What's your favorite movie?"
                value={movie}
                onChange={(e) => setMovie(e.target.value)}
                variant="outlined"
                fullWidth
                required
                sx={{
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        },
                        '& fieldset': {
                            borderColor: 'rgba(255, 255, 255, 0.3)',
                        },
                        '&:hover fieldset': {
                            borderColor: 'rgba(255, 255, 255, 0.5)',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                        }
                    },
                    '& .MuiInputLabel-root': {
                        color: 'rgba(255, 255, 255, 0.7)',
                        '&.Mui-focused': {
                            color: '#1976d2'
                        }
                    }
                }}
            />
            <Button 
                type="submit" 
                variant="contained" 
                disabled={!movie || isLoading}
                sx={{ 
                    mt: 2,
                    py: 1.5,
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                    },
                    '&:disabled': {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        color: 'rgba(255, 255, 255, 0.3)'
                    }
                }}
            >
                {isLoading ? <CircularProgress size={24} /> : 'Get Fact'}
            </Button>
        </Box>
    );
};

export default MovieForm; 